// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"vendors-node_modules_react-dom_index_js":"a7d33741b3f3d6ee9b48","vendors-node_modules_react_index_js":"03e398b1eddc9c6881c2","vendors-node_modules_fcamna_react-library_index_js":"8d6ef0de81bc56d77a41","src_modules_App_tsx":"d292438c5b630cfcd0ad"}[chunkId] + ".js";
};